<template>
  <div class="form__field-box" data-vv-value-path="model" :data-vv-as="label">
    <label class="form__label" v-if="label">
      {{ label }}
    </label>
    <div class="v-autocomplete v-autocomplete-public">
      <div class="v-autocomplete__input">
        <div
          class="v-input"
          :class="{
            'v-input--is-disabled': disabled,
            'v-input__error--border':
              (!!errors.has(newName) && !phrase) ||
              (!!errors.has(newName) && isDirtyData),
          }"
        >
          <input type="hidden" :name="name" :value="model" :rules="rules" />
          <input
            class="v-input__field"
            v-model="phrase"
            type="text"
            :name="`_labels[${name}]`"
            autocomplete="off"
            @keyup="suggest"
            @keydown="clearTimeout"
            @keydown.enter.prevent
            @focus="showList = true"
            :disabled="disabled"
            @blur="blur"
          />
        </div>
        <ul class="v-autocomplete__list" v-if="showList">
          <li
            v-for="item in suggestions"
            class="v-autocomplete__item"
            :class="{ 'v-autocomplete__item--is-selected': item === selected }"
            :key="item.id"
            @click="pick(item)"
          >
            {{ resolve(item) }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import field from "../mixins/field";
import $ from "jquery";

export default {
  props: {
    value: {
      default() {
        return [];
      },
    },
    resolve: {
      default: (hit) => {
        return hit.name;
      },
      type: Function,
    },
    endpoint: {
      default: "/admin/autocomplete/locations",
      type: String,
    },
    base: {
      default: "",
      type: String,
    },
    initial: {
      default: "",
      type: String,
    },
  },
  data() {
    return {
      isDirtyData: null,
      showList: false,
      suggestions: [],
      selected: null,
      phrase: this.initial,
      typingTimer: null,
      doneTypingInterval: 700,
    };
  },
  methods: {
    suggest(event) {
      let keyCode = event.keyCode;

      switch (keyCode) {
        case 38:
          if (_.indexOf(this.suggestions, this.selected) === 0) {
            this.selected = this.suggestions[this.suggestions.length - 1];
          } else {
            this.selected = this.suggestions[
              _.indexOf(this.suggestions, this.selected) - 1
            ];
          }

          break;
        case 40:
          if (
            _.indexOf(this.suggestions, this.selected) ===
            this.suggestions.length - 1
          ) {
            this.selected = this.suggestions[0];
          } else {
            this.selected = this.suggestions[
              _.indexOf(this.suggestions, this.selected) + 1
            ];
          }

          break;
        case 13:
          this.pick(this.selected);

          break;
        case 9:
          break;
        default:
          this.typing();
          break;
      }
    },
    pick(item) {
      this.phrase = this.resolve(item);
      this.showList = false;
      this.model = item.id;
      this.selected = null;
      this.isDirtyData = false;
    },
    typing() {
      clearTimeout(this.typingTimer);
      this.typingTimer = setTimeout(this.doneTyping, this.doneTypingInterval);

      this.showList = true;
      this.model = this.phrase;
      this.isDirtyData = true;
    },
    clearTimeout() {
      clearTimeout(this.typingTimer);
    },
    doneTyping() {
      $.get(this.endpoint + "?q=" + this.phrase).then((response) => {
        this.suggestions = response;
      });
    },
    blur() {
      setTimeout(() => {
        this.showList = false;
      }, 300);
    },
    changePhrase(value) {
      this.phrase = value;
    },
  },
  mixins: [field],
  watch: {
    model(value) {
      if (!value) {
        this.phrase = null;
      }
      this.$emit("update", value);
      this.$emit("input", value);
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/admin/components/VAutocompletePublic.vue